import type { PropsWithChildren } from "react";

import type { FlexProps } from "@similarweb/ui-components/foundations";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface IFooterProps extends PropsWithChildren, Pick<FlexProps, "flexWrap"> {
    label?: string;
}

export const Footer = ({ children, label, flexWrap }: IFooterProps) => (
    <Flex
        alignItems="center"
        gap="8px 16px"
        flexWrap={flexWrap}
    >
        {label ? (
            <Text
                fontVariant="chip1"
                flexShrink={0}
            >
                {label}
            </Text>
        ) : null}
        {children}
    </Flex>
);
